/* eslint-disable max-lines */
import { Reducer } from 'redux';
import IAssessmentState from '../state/AssessmentState';
import { AssessmentAction, AssessmentActionTypes } from '../actions/AssessmentActions';
import {
  IAssessmentOptions,
  IAssessmentQuestions,
  IAssessessments,
  IDownloadAssessmentResponse,
  ICloudAssessment,
  IDownloadCloudAssessmentResponse,
} from '../../models/AssessmentModels';

export const initialState: IAssessmentState = {
  error: undefined,
  assessmentOptions: {
    cspList: [],
    capabilitiesList: [],
  },
  assessmentQuestions: {
    capabilities: [],
    cloudServiceProviders: [],
  },
  assessments: [],
  downloadContent: {
    content: [],
    assessmentName: '',
  },
  cloudAssessment: {
    Id: '',
    account_id: '',
    assessment_data: [],
    assessment_date: '',
    assessment_name: '',
    author: '',
    client_name: '',
    cloud_providers: [],
    created_at: '',
    summary: '',
    version: '',
  },
  cloudAssessments: [],
  downloadCloudAssessmentReport: {
    download_url: '',
  },
  loading: false,
  loadingCount: 0,
};

export const assessmentReducer: Reducer<IAssessmentState> = (
  state = initialState,
  action: AssessmentAction,
) => {
  switch (action.type) {
    case AssessmentActionTypes.FETCH_ASSESS_OPTIONS_START:
    case AssessmentActionTypes.FETCH_ASSESSMENTS_START:
      return { ...state, loadingCount: state.loadingCount + 1, error: undefined };

    case AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_START:
      return {
        ...state,
        assessmentQuestions: {
          capabilities: [],
          cloudServiceProviders: [],
        },
        loadingCount: state.loadingCount + 1,
        error: undefined,
      };

    case AssessmentActionTypes.DOWNLOAD_ASSESSMENT_START:
      return {
        ...state,
        downloadContent: {
          content: [],
          assessmentName: '',
        },
        loading: true,
        error: undefined,
      };
    case AssessmentActionTypes.SUBMIT_ASSESSMENT_START:
    case AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_START:
      return {
        ...state,
        downloadCloudAssessmentReport: {
          download_url: '',
        },
        cloudAssessment: {
          Id: '',
          account_id: '',
          assessment_data: [],
          assessment_date: '',
          assessment_name: '',
          author: '',
          client_name: '',
          cloud_providers: [],
          created_at: '',
          summary: '',
          version: '',
        },
        loading: true,
        error: undefined,
      };
    case AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_START:
      return {
        ...state,
        downloadCloudAssessmentReport: {
          download_url: '',
        },
        loading: true,
        error: undefined,
      };
    case AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_START:
    case AssessmentActionTypes.DELETE_ASSESSMENT_START:
      return { ...state, loading: true, error: undefined };

    case AssessmentActionTypes.FETCH_ASSESS_OPTIONS_SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        assessmentOptions: action.data as IAssessmentOptions,
      };
    case AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        assessmentQuestions: action.data as IAssessmentQuestions,
      };
    case AssessmentActionTypes.FETCH_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        assessments: action.data as Array<IAssessessments>,
      };
    case AssessmentActionTypes.DOWNLOAD_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadContent: action.data as IDownloadAssessmentResponse,
      };

    case AssessmentActionTypes.SUBMIT_ASSESSMENT_SUCCESS:
    case AssessmentActionTypes.DELETE_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        cloudAssessment: action.data as ICloudAssessment,
      };

    case AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        cloudAssessments: action.data as Array<ICloudAssessment>,
      };

    case AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadCloudAssessmentReport: action.data as IDownloadCloudAssessmentResponse,
      };

    case AssessmentActionTypes.FETCH_ASSESS_OPTIONS_ERROR:
    case AssessmentActionTypes.FETCH_ASSESS_QUESTIONS_ERROR:
    case AssessmentActionTypes.FETCH_ASSESSMENTS_ERROR:
      return { ...state, loadingCount: Math.max(0, state.loadingCount - 1), error: action.data };
    case AssessmentActionTypes.DOWNLOAD_ASSESSMENT_ERROR:
    case AssessmentActionTypes.SUBMIT_ASSESSMENT_ERROR:
      return {
        ...state,
        loading: false,
        loadingCount: 0,
        error: action.data,
      };
    case AssessmentActionTypes.DELETE_ASSESSMENT_ERROR:
      return { ...state, loading: false, error: action.data };

    case AssessmentActionTypes.ASSESSMENT_HARD_RELOAD:
      return {
        ...state,
        loading: false,
        loadingCount: 0,
      };

    case AssessmentActionTypes.GENERATE_CLOUD_ASSESSMENT_ERROR:
    case AssessmentActionTypes.FETCH_CLOUD_ASSESSMENTS_ERROR:
    case AssessmentActionTypes.DOWNLOAD_CLOUD_ASSESSMENT_REPORT_ERROR:
      return {
        ...state,
        loadingCount: 0,
        loading: false,
        error: action.data,
      };

    case AssessmentActionTypes.RESET_DOWNLOAD_CLOUD_ASSESSMENT_REPORT_DATA:
      return {
        ...state,
        cloudAssessment: {
          Id: '',
          account_id: '',
          assessment_data: [],
          assessment_date: '',
          assessment_name: '',
          author: '',
          client_name: '',
          cloud_providers: [],
          created_at: '',
          summary: '',
          version: '',
        },
        downloadCloudAssessmentReport: {
          download_url: '',
        },
      };
    default:
      return state;
  }
};
